
import styled from 'styled-components';
import { Link } from 'react-router-dom';
export const ItemWrapper = styled.div`
  overflow: hidden;
  background: #FFFFFF;
  box-shadow: 0px 0px 1px #D6D6D6, 0px 3px 8px -1px rgba(214, 214, 214, 0.31);
  border-radius: 10px;
  padding: calc(100vw * (12 / 375)) 0;
`
export const ItemGradientFilter = styled.div`
  background: linear-gradient( 90deg ,#ffffff00 5.83%,#ffffff00 52.5%,#FFFFFF 100%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const ItemTop = styled.div` 
  &::after{
    display: block;
    clear: both;
    content: " ";
  }
  margin-bottom: calc(100vw * (16 / 375));
  padding: 0 0 0 calc(100vw * (82 / 375))
`

export const TopInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: calc(100vw * (10 / 375));
  width : 100%;
  justify-content: space-between;
  padding-right: calc(100vw * (15 / 375));
`;
export const InfoLeft = styled.div`
  display: flex;
  align-items: center;
`;
export const InfoRight = styled.div`
`;


export const UserName = styled.span`
  display: inline-block;
  font-weight: bold;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #121212;
  margin-right: calc(100vw * (5 / 375));
`;

export const ProfileImgWrapper = styled.div`
  width : calc(100vw * (49 / 375));
  height : calc(100vw * (49 / 375));
  border-radius: 100%;
  overflow: hidden;
  float: left;
  margin-left: calc(100vw * (-60 / 375));
`;
export const ProfileImg = styled.img`
  width : 100%;
  height: 100%;
  object-fit: cover;
`;


export const ItemMid = styled.div` 
  padding: 0 calc(100vw * (22 / 375));
`


export const ActivityWrapper = styled.div`
  font-weight: bold;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #121212;
  margin-bottom : calc(100vw * (8 / 375));
`

export const ActivityTxt = styled.span`
  font-weight: normal;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #121212;
  margin-bottom : calc(100vw * (8 / 375));
`
export const TitleWrapper = styled.div`
  font-weight: normal;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #121212;
`
export const DescriptionWrapper = styled.div`
margin-bottom: calc(100vw * (20 / 375));
`;

export const DescriptionTxt = styled.span`

  font-style: normal;
font-size: calc(100vw * (14 / 375));
line-height: calc(100vw * (20 / 375));
color: #121212;

white-space: pre-wrap;
overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-box-orient: vertical;

`;
export const EllipsisDescriptionTxt = styled(DescriptionTxt)`
-webkit-line-clamp: 2;

`;
export const MoreBtn = styled.span`
  display: inline-block;
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20 / 375));

  color: #989898;
`

export const LocationImgWrapper = styled.span`
  display: inline-block;
  width : calc(100vw * (9 / 375));
  height: calc(100vw * (11 / 375));
`;
export const LocationImg = styled.img``;
export const LocationTxt = styled.span`
font-weight: normal;
font-size: calc(100vw * (10 / 375));
line-height: calc(100vw * (14 / 375));
color: #4E4E4E;
`;

export const CategoryItem = styled.span`
  display: inline-block;
  padding: calc(100vw * (3 / 375)) calc(100vw * (10 / 375));
  background: #F7F7F7;
  border-radius: calc(100vw * (25 / 375));
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (17 / 375));
  color: #7F7F7F;
  margin-right: calc(100vw * (5 / 375));
`;

export const ProfileOptionBtn = styled.span`
  display: inline-block;
  width : calc(100vw * (24 / 375));
  height : calc(100vw * (24 / 375));
`;
export const OptionImg = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

export const MbtiItem = styled(CategoryItem)`
  border: 1px solid #F7F7F7;
  background: white;
  margin-bottom: calc(100vw * (10 / 375));
`;
  

export const TagList = styled.div`
  white-space: nowrap;
  position: relative;
`;

export const ItemBottom = styled.div`
  padding: 0 calc(100vw * (22 / 375));
`;
export const JoinBtn = styled(Link)`
  background: #FFCF19;
  border-radius: 8px;
  width: 100%;
  display: inline-block;
  text-align: center;
  line-height:calc(100vw * (46 / 375));
  height: calc(100vw * (46 / 375));
  font-weight: normal;
  font-size: calc(100vw * (14 / 375));
  color: #4E4E4E;
`;
export const JoinBtnTxt = styled.span`
  display: inline-block;
  font-weight: bold;
  margin-right: calc(100vw * (6 / 375));
`